"use client"

import { Award } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AwardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AwardIcon = component(Icon)({ as: Award })
